// src/store/roster/actions/actionsCreators.js

import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_MAIN_URL || "http://localhost:8082";

// Action Types
export const GET_ROSTER_REQUEST = "GET_ROSTER_REQUEST";
export const GET_ROSTER_SUCCESS = "GET_ROSTER_SUCCESS";
export const GET_ROSTER_FAILURE = "GET_ROSTER_FAILURE";

export const SAVE_ROSTER_REQUEST = "SAVE_ROSTER_REQUEST";
export const SAVE_ROSTER_SUCCESS = "SAVE_ROSTER_SUCCESS";
export const SAVE_ROSTER_FAILURE = "SAVE_ROSTER_FAILURE";

export const SUBMIT_ROSTER_REQUEST = "SUBMIT_ROSTER_REQUEST";
export const SUBMIT_ROSTER_SUCCESS = "SUBMIT_ROSTER_SUCCESS";
export const SUBMIT_ROSTER_FAILURE = "SUBMIT_ROSTER_FAILURE";

export const DOWNLOAD_ROSTER_PDF_REQUEST = "DOWNLOAD_ROSTER_PDF_REQUEST";
export const DOWNLOAD_ROSTER_PDF_SUCCESS = "DOWNLOAD_ROSTER_PDF_SUCCESS";
export const DOWNLOAD_ROSTER_PDF_FAILURE = "DOWNLOAD_ROSTER_PDF_FAILURE";

/**
 * Get roster for a team's tournament registration
 */
export const getRoster = (teamId, divisionId, token) => async (dispatch) => {
  dispatch({ type: GET_ROSTER_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/tournament-rosters`, {
      params: { teamId, divisionId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: GET_ROSTER_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_ROSTER_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to load roster");
  }
};

/**
 * Save roster as draft
 */
export const saveRoster = (rosterData, token) => async (dispatch) => {
  dispatch({ type: SAVE_ROSTER_REQUEST });
  try {
    const response = await axios.post(
      `${API_BASE_URL}api/tournament-rosters/save`,
      rosterData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: SAVE_ROSTER_SUCCESS, payload: response.data });
    toast.success("Roster saved successfully!");
    return response.data;
  } catch (error) {
    dispatch({ type: SAVE_ROSTER_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to save roster");
    throw error;
  }
};

/**
 * Submit roster (final)
 */
export const submitRoster = (rosterData, token) => async (dispatch) => {
  dispatch({ type: SUBMIT_ROSTER_REQUEST });
  try {
    const response = await axios.post(
      `${API_BASE_URL}api/tournament-rosters/submit`,
      rosterData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: SUBMIT_ROSTER_SUCCESS, payload: response.data });
    toast.success("Roster submitted successfully!");
    return response.data;
  } catch (error) {
    dispatch({ type: SUBMIT_ROSTER_FAILURE, payload: error.message });
    toast.error(error.response?.data || "Failed to submit roster");
    throw error;
  }
};

/**
 * Download roster PDF
 */
export const downloadRosterPDF = (rosterId, token) => async (dispatch) => {
  dispatch({ type: DOWNLOAD_ROSTER_PDF_REQUEST });
  try {
    const response = await axios.get(
      `${API_BASE_URL}api/tournament-rosters/${rosterId}/pdf`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `roster_${rosterId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    dispatch({ type: DOWNLOAD_ROSTER_PDF_SUCCESS });
    toast.success("PDF downloaded successfully!");
  } catch (error) {
    dispatch({ type: DOWNLOAD_ROSTER_PDF_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to download PDF");
  }
};

/**
 * Preview roster PDF (without saving)
 */
export const previewRosterPDF = (rosterData, token) => async (dispatch) => {
  dispatch({ type: DOWNLOAD_ROSTER_PDF_REQUEST });
  try {
    const response = await axios.post(
      `${API_BASE_URL}api/tournament-rosters/preview-pdf`,
      rosterData,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    
    // Open PDF in new tab
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    
    dispatch({ type: DOWNLOAD_ROSTER_PDF_SUCCESS });
  } catch (error) {
    dispatch({ type: DOWNLOAD_ROSTER_PDF_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to preview PDF");
  }
};
